export default {
  site_name: "Kakobuy Finds",
  site_tagline: "Najlepsze Kakobuy Spreadsheet i Finds w Polsce",
  nav_home: "Strona Główna",
  nav_categories: "Kategorie",
  nav_spreadsheet: "Spreadsheet",
  nav_articles: "Artykuły",
  nav_comparison: "Porównania",
  nav_safety: "Bezpieczeństwo",
  btn_kakobuy_sheet: "kakobuy sheet",
  btn_buy_now: "buy it now",
  btn_view_spreadsheet: "Zobacz Kakobuy Spreadsheet",
  btn_check_finds: "Sprawdź najnowsze Finds",
  btn_read_article: "Przeczytaj artykuł",
  btn_all_categories: "Wszystkie kategorie",
  hero_title: "Kakobuy Spreadsheet Polska – Najlepsze Listy Produktów i Finds 2026",
  hero_subtitle: "Znajdź najlepsze Kakobuy Spreadsheet, popularne produkty, aktualne listy zakupowe oraz szczegółowe przewodniki dla użytkowników z Polski.",
  hero_badge: "Zaktualizowano Lipiec 2026",
  categories_title: "Przeglądaj kategorie produktów",
  categories_subtitle: "Znajdź najlepsze okazje w każdej kategorii – od obuwia po akcesoria",
  categories_desc: "Kliknij kategorię, aby przejść do pełnej listy produktów na naszej głównej platformie zakupowej.",
  seo_section_title: "Artykuły SEO o Kakobuy Sheet",
  seo_section_label: "/ Artykuły SEO",
  seo_section_text: "Kakobuy Spreadsheet to jedno z najbardziej wszechstronnych narzędzi dla osób poszukujących sprawdzonych list produktów do zakupów online. W naszych artykułach znajdziesz szczegółowe analizy, porównania platform oraz praktyczne poradniki, które pomogą Ci podejmować lepsze decyzje zakupowe.",
  seo_section_cta: "Przeczytaj poradniki",
  seo_section_author: "Nasz zespół ekspertów regularnie aktualizuje wszystkie artykuły, abyś zawsze miał dostęp do najświeższych informacji.",
  comparison_title: "Porównania Spreadsheet",
  comparison_subtitle: "Kakobuy vs konkurencja – sprawdź, która platforma jest najlepsza",
  kakobuy_vs_cssbuy: "Kakobuy vs CSSBuy",
  kakobuy_vs_cssbuy_desc: "Porównanie jakości spreadsheet, bazy produktów i doświadczeń użytkowników obu platform.",
  kakobuy_vs_superbuy: "Kakobuy vs Superbuy",
  kakobuy_vs_superbuy_desc: "Analiza funkcji, cen i dostępności produktów w obu serwisach.",
  kakobuy_vs_oopbuy: "Kakobuy vs Oopbuy",
  kakobuy_vs_oopbuy_desc: "Sprawdź, która platforma oferuje lepsze listy zakupowe i wsparcie dla polskich użytkowników.",
  cta_title: "Gotowy na zakupy?",
  cta_subtitle: "Przejdź do pełnej bazy Kakobuy Spreadsheet i znajdź najlepsze okazje już dziś.",
  cta_desc: "Nasza główna platforma oferuje tysiące sprawdzonych produktów, aktualne ceny i szczegółowe listy zakupowe. Wszystko w jednym miejscu, dostępne natychmiast.",
  footer_categories: "Kategorie",
  footer_links: "Przydatne linki",
  footer_articles: "Artykuły",
  footer_safety: "Bezpieczeństwo",
  footer_privacy: "Polityka prywatności",
  footer_terms: "Regulamin",
  footer_disclaimer: "Zastrzeżenie",
  footer_copyright: "© 2026 Kakobuy Finds. Wszelkie prawa zastrzeżone.",
  footer_disclaimer_text: "Ta strona jest niezależnym źródłem informacji. Nie jesteśmy bezpośrednio powiązani z żadną z wymienionych platform.",
  article_back_home: "← Powrót do strony głównej",
  article_related: "Powiązane artykuły",
  article_read_more: "Czytaj więcej",
};